export const OTPConstants = {

    POST_OTP_REQUEST: 'POST_OTP_REQUEST',
    POST_OTP_SUCCESS: 'POST_OTP_SUCCESS',
    POST_OTP_FAILURE: 'POST_OTP_FAILURE',

    POST_VERIFY_OTP_REQUEST: 'POST_VERIFY_OTP_REQUEST',
    POST_VERIFY_OTP_SUCCESS: 'POST_VERIFY_OTP_SUCCESS',
    POST_VERIFY_OTP_FAILURE: 'POST_VERIFY_OTP_FAILURE',
};